import { KeyboardEvent } from 'react'

import { AREA_DATA, getContrastingTextColor, getPrefectureColor, PREFECTURE_GRID } from '../utils'
import styles from './styles.module.scss'

const SVG_CELL = 40
const SVG_TILE = 37
const SVG_OFFSET_X = 16
const SVG_OFFSET_Y = 12

type Props = {
  selectedPrefecture: string
  isMobile: boolean
  onSelect: (prefecture: string) => void
}

const getShortPrefectureName = (prefecture: string, isMobile: boolean): string => {
  if (prefecture === '北海道') return isMobile ? '北海' : '北海道'
  return prefecture.replace(/[都道府県]$/, '').slice(0, isMobile ? 2 : 3)
}

const JapanMap = ({ selectedPrefecture, isMobile, onSelect }: Props): JSX.Element => {
  const selectByKeyboard = (event: KeyboardEvent<SVGGElement>, prefecture: string) => {
    if (event.key !== 'Enter' && event.key !== ' ') return
    event.preventDefault()
    onSelect(prefecture)
  }

  return (
    <div className={styles.mapCard}>
      <div className={styles.mapLegend}>
        <span>大募集中</span>
        <span className={styles.legendBar} aria-hidden="true" />
        <span>達成</span>
      </div>
      <svg className={styles.japanMap} viewBox="0 0 552 552" aria-label="日本地図 募集エリア">
        {Object.entries(PREFECTURE_GRID).map(([prefecture, grid]) => {
          const width = SVG_CELL * (grid.w ?? 1) - (SVG_CELL - SVG_TILE)
          const height = SVG_CELL * (grid.h ?? 1) - (SVG_CELL - SVG_TILE)
          const x = SVG_OFFSET_X + grid.gx * SVG_CELL
          const y = SVG_OFFSET_Y + grid.gy * SVG_CELL
          const color = getPrefectureColor(AREA_DATA[prefecture])
          const textColor = getContrastingTextColor(color)
          const isSelected = selectedPrefecture === prefecture
          return (
            <g
              className={`${styles.tileGroup} ${isSelected ? styles.selected : ''}`}
              key={prefecture}
              role="button"
              tabIndex={0}
              aria-label={`${prefecture}を選択`}
              aria-pressed={isSelected}
              onClick={() => onSelect(prefecture)}
              onKeyDown={(event) => selectByKeyboard(event, prefecture)}
            >
              <rect
                x={x}
                y={y}
                width={width}
                height={height}
                rx={5}
                fill={color}
                stroke="#fff"
                strokeWidth={2}
              />
              <text
                className={textColor === '#333333' ? styles.darkTileLabel : undefined}
                x={x + width / 2}
                y={y + height / 2 + 4}
                textAnchor="middle"
                fill={textColor}
              >
                {getShortPrefectureName(prefecture, isMobile)}
              </text>
            </g>
          )
        })}
      </svg>
    </div>
  )
}

export default JapanMap
